import { Typography } from '@mui/material';

// Components
import { IsLastType, StyledWhiteBox } from 'src/features/PortDetail/config';
import { getArrayDefault } from 'src/utils/helpers/arrayHelpers';

// Utilities
import { IDistributionCenter } from 'src/utils/typings/response';
import { useQueryDataDistributionCenter } from 'src/services/queries';
import { renderNumberOrDefault, renderTextOrDefault } from 'src/utils/helpers/stringHelpers';
import Table from 'src/components/Table';

interface IProps {
  locode: string;
  isLast: number;
}

const DistributionCenterTable = ({ locode = '', isLast }: IProps) => {
  const { data, isFetching } = useQueryDataDistributionCenter({ locode, isLast });
  const dataDistributionCenter = getArrayDefault(data?.data);

  const configColumn: ConfigCell<IDistributionCenter>[] = [
    {
      id: 'port_name',
      disablePadding: true,
      disableSort: true,
      label: 'Destination',
      cell: (row: IDistributionCenter) => {
        return (
          <Typography variant="body2" color="text.secondary">
            {renderTextOrDefault(row?.port_name)}
          </Typography>
        );
      },
    },
    {
      id: 'traffic_percent',
      disablePadding: true,
      disableSort: true,
      label: 'Traffics (%)',
      cell: (row: IDistributionCenter) => {
        return (
          <Typography variant="body2" color="text.secondary">
            {renderNumberOrDefault(row?.traffic_percent)}
          </Typography>
        );
      },
    },
    {
      id: 'locode',
      disablePadding: true,
      disableSort: true,
      label: 'Locode',
      cell: (row: IDistributionCenter) => {
        return (
          <Typography variant="body2" color="text.secondary">
            {renderTextOrDefault(row?.locode)}
          </Typography>
        );
      },
    },
    {
      id: 'arrival_mode',
      disablePadding: true,
      disableSort: true,
      label: 'Arrival Mode',
      cell: (row: IDistributionCenter) => {
        return (
          <Typography variant="body2" color="text.secondary">
            {renderTextOrDefault(row?.arrival_mode)}
          </Typography>
        );
      },
    },
    {
      id: 'km',
      disablePadding: true,
      disableSort: true,
      label: 'Km',
      cell: (row: IDistributionCenter) => {
        return (
          <Typography variant="body2" color="text.secondary">
            {renderTextOrDefault(row?.km)}
          </Typography>
        );
      },
    },
  ];

  return (
    <StyledWhiteBox display="flex" flexDirection="column" gap={2}>
      <Typography variant="h5" align="left">
        {isLast === IsLastType.Outbound ? 'Origin outbound containers' : 'Final destination inbound containers'}
      </Typography>{' '}
      <Table
        data={dataDistributionCenter}
        configColumn={configColumn}
        loading={isFetching}
        dataKey="port_name"
        isPagination={false}
        maxRow={10}
        totalRecords={dataDistributionCenter.length}
      />
    </StyledWhiteBox>
  );
};

export default DistributionCenterTable;
